import { RequestErrorDataApi } from "../errors"
import { dataAPI } from "./api"

export const getAutoCompleteSuggestions = async (
    itemId: number,
    fieldDefinitionId: string,
    searchText: string,
    queryParameters?: Api.DataApiQueryOptions,
    receiver?: Api.Receiver,
    defaultErrorMessage?: string,
): Promise<string[]> => {
    try {
        return (
            await dataAPI.getJSON<Api.SuggestionsResponse>(
                `ItemFields(itemId=${itemId},fieldDefinitionId='${fieldDefinitionId}')/TF.TextItemField/GetSuggestions(searchText='${searchText}')`,
                queryParameters,
                receiver,
            )
        ).value
    } catch (error) {
        if (error instanceof Response) {
            const errorMessage =
                error instanceof Error
                    ? error.message
                    : defaultErrorMessage || ""
            throw await RequestErrorDataApi.create(
                errorMessage,
                error.status,
                error,
            )
        }
        throw error
    }
}
